module.exports = __webpack_public_path__ + "static/media/energy-outgoing.a6760ad7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/energy-outgoing.jpg
// module id = 629
// module chunks = 11